module.exports = __webpack_public_path__ + "img/3.940e1304.jpg";